import { TFunction } from "i18next";
import { z } from "zod";

import { documentsUploadSchema } from "src/core/forms/folder/documentsUpload.schema";

export const documentSchema = (t: TFunction) =>
  z.object({
    documents: documentsUploadSchema(t),
  });
export type DocumentFormValues = z.infer<ReturnType<typeof documentSchema>>;

export const defaultDocumentValues = (): DocumentFormValues => {
  return {
    documents: {},
  };
};
